import type { LuggageTypeEntry } from '../engine/types'
import type { GenericEntryLinks, GenericValues } from './generic'
import { createGenericEntry } from './generic'

export function createMusicInstrumentEntry({ links }: { links?: GenericEntryLinks } = {}): LuggageTypeEntry<GenericValues> {
  return createGenericEntry({ links })
}
